<template>
    <div class="mc-root nc-list">
      <div class="mc-page">
        <mc-page-header title="Riepilogo NC">
            <template #actions>
                <nc8d-reprocess :disabled="loading || bulkBusy || confirmdialog" @updated="getData" />
                <v-btn outlined :loading="loading" :disabled="bulkBusy || confirmdialog" @click="getData">
                    <v-icon left>mdi-refresh</v-icon>Aggiorna
                </v-btn>
            </template>
        </mc-page-header>
        <section class="mc-card mc-filters nc-filters" aria-label="Filtri NC">
        <v-row dense class="nc-filter-fields" role="search">
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="search"
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                    label="Cerca NC, cliente, articolo o riferimento"
                    prepend-inner-icon="mdi-magnify"
                    :disabled="bulkBusy || confirmdialog"
                />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select
                    v-model="filtro.risolte"
                    :items="materialOptions"
                    label="Materiale gestito"
                    outlined
                    dense
                    hide-details="auto"
                    :disabled="bulkBusy || confirmdialog"
                    @change="filtersChanged"
                />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select
                    v-model="filtro.periodo"
                    :items="periodOptions"
                    label="Periodo di inserimento"
                    outlined
                    dense
                    hide-details="auto"
                    :disabled="bulkBusy || confirmdialog"
                    @change="filtersChanged"
                />
            </v-col>
        </v-row>
        <v-btn-toggle v-model="filtro8d" mandatory dense class="mc-vseg nc-status-filters" aria-label="Stato 8D">
            <v-btn value="all" :aria-pressed="filtro8d === 'all'" :disabled="bulkBusy || confirmdialog">Tutte ({{ formatCount("all") }})</v-btn>
            <v-btn value="pending" :aria-pressed="filtro8d === 'pending'" :disabled="bulkBusy || confirmdialog"
                >Incomplete ({{ formatCount("pending") }})</v-btn
            >
            <v-btn value="available" :aria-pressed="filtro8d === 'available'" :disabled="bulkBusy || confirmdialog"
                >Complete ({{ formatCount("available") }})</v-btn
            >
        </v-btn-toggle>
        </section>
        <mc-state-message v-if="loadError" state="error" :title="loadError" @retry="getData" />
        <div v-if="bulkError" class="nc-warning" role="alert"><v-icon>mdi-alert</v-icon>{{ bulkError }}</div>
        <mc-state-message v-if="loading && !righe.length" state="loading" />
        <v-progress-linear v-else-if="loading" indeterminate class="nc-progress" aria-label="Caricamento NC" />
        <section v-if="!loadError" class="nc-results" aria-label="Elenco NC" :aria-busy="String(loading)">
        <div v-if="canManageNc && !loadError && righe.length" class="nc-selection">
            <v-checkbox
                :input-value="allSelected"
                :indeterminate="selectedRows.length > 0 && !allSelected"
                label="Seleziona pagina"
                dense
                color="primary"
                hide-details
                class="mt-0 mr-4"
                :disabled="loading || bulkBusy || confirmdialog"
                @change="selectPage"
            />
            <v-btn
                v-if="selectedRows.length"
                depressed
                color="primary"
                :disabled="loading"
                :loading="bulkBusy"
                @click="confirmdialog = true"
                >Materiale gestito ({{ selectedRows.length }})</v-btn
            >
        </div>
        <v-data-iterator
            v-if="!loadError"
            :items="righe"
            :options.sync="tableOptions"
            :server-items-length="total_items"
            :loading="loading"
            :footer-props="{
                'items-per-page-options': [50, 100, 500],
                'disable-pagination': bulkBusy || confirmdialog,
                'disable-items-per-page': bulkBusy || confirmdialog,
            }"
            no-data-text="Nessuna NC corrisponde ai filtri selezionati."
        >
            <template #no-data>
                <mc-state-message v-if="!loading" state="empty" title="Nessuna NC corrisponde ai filtri selezionati." />
            </template>
            <template v-slot:default="props">
                <div v-if="$vuetify.breakpoint.smAndDown" class="nc-mobile-list">
                    <v-card v-for="row in props.items" :key="rowKey(row)" outlined class="mc-card nc-mobile-card">
                        <v-card-text>
                            <div class="d-flex align-center">
                                <v-checkbox
                                    v-model="selected"
                                    :value="rowKey(row)"
                                    :disabled="selectionDisabled(row)"
                                    :aria-label="`Seleziona ${row.numero} riga ${row.riga}`"
                                    hide-details
                                    dense
                                    color="primary"
                                    class="mt-0 mr-2"
                                />
                                <strong class="mc-code">{{ row.numero }} / {{ row.riga }}</strong>
                            </div>
                            <div class="my-2">
                                <mc-status-chip :tone="stageTone(row)" :icon="stageIcon(row)" :label="stage(row)" />
                            </div>
                            <bt-articolo class="mc-code" :codice="row.articolo" />
                            <div>{{ row.articolo_descrizione }}</div>
                            <div>
                                {{ formatDate(row.data_inserimento) }} · {{ row.rif || "Senza riferimento" }}
                            </div>
                            <div class="mt-2">Materiale: {{ row.risolta === 2 ? "gestito" : "da gestire" }}</div>
                            <div>{{ row.nc_gestione }}</div>
                            <div>
                                ODP origine: {{ row.odp || "—" }} · Fase origine:
                                {{ phaseLabel(row) }}
                            </div>
                            <details class="nc-details">
                                <summary>Problema, azioni e foto</summary>
                                <div>Causa: {{ row.nc_causa || "—" }} · Origine: {{ row.nc_origine || "—" }}</div>
                                <p class="mt-2">{{ row.problema || "Problema da compilare" }}</p>
                                <p>Trattamento: {{ row.correzione || "—" }}</p>
                                <p>Azione correttiva: {{ row.soluzione || "—" }}</p>
                                <files-n-c :numero="row.numero" :riga="row.riga" deferred />
                            </details>
                            <nc-list-actions
                                :row="row"
                                :can-edit="canManageNc"
                                :disabled="loading || bulkBusy || confirmdialog"
                                :opening8d="opening8d"
                                @open-8d="open8d"
                                @edit="editNc"
                            />
                        </v-card-text>
                    </v-card>
                </div>
                <v-simple-table v-else class="mc-vtable nc-table">
                    <thead>
                        <tr>
                            <th scope="col">Seleziona</th>
                            <th scope="col">NC / ODP origine</th>
                            <th scope="col">Stato 8D / materiale</th>
                            <th scope="col">Articolo</th>
                            <th scope="col">Azioni</th>
                            <th scope="col">Causa / origine</th>
                            <th scope="col">Problema</th>
                            <th scope="col">Trattamento</th>
                            <th scope="col">Azione correttiva</th>
                            <th scope="col">Foto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="row in props.items"
                            :key="rowKey(row)"
                            :class="row['8d_disponibile'] ? 'status-8d-available' : 'status-8d-incomplete'"
                        >
                            <td>
                                <v-checkbox
                                    v-model="selected"
                                    :value="rowKey(row)"
                                    :disabled="selectionDisabled(row)"
                                    :aria-label="`Seleziona ${row.numero} riga ${row.riga}`"
                                    hide-details
                                    dense
                                    color="primary"
                                    class="mt-0"
                                />
                            </td>
                            <td class="nc-identity">
                                <strong class="mc-code">{{ row.numero }} / {{ row.riga }}</strong>
                                <div class="mc-caption">{{ formatDate(row.data_inserimento) }}</div>
                                <div>{{ row.rif }}</div>
                                <div>ODP: <span class="mc-code">{{ row.odp || "—" }}</span></div>
                                <div>Fase origine: {{ phaseLabel(row) }}</div>
                            </td>
                            <td>
                                <mc-status-chip :tone="stageTone(row)" :icon="stageIcon(row)" :label="stage(row)" />
                                <div class="mt-2">Materiale {{ row.risolta === 2 ? "gestito" : "da gestire" }}</div>
                                <div class="mc-caption">{{ row.nc_gestione }}</div>
                            </td>
                            <td>
                                <bt-articolo class="mc-code" :codice="row.articolo" />
                                <div>{{ row.articolo_descrizione }}</div>
                            </td>
                            <td>
                                <nc-list-actions
                                    :row="row"
                                    :can-edit="canManageNc"
                                    :disabled="loading || bulkBusy || confirmdialog"
                                    :opening8d="opening8d"
                                    @open-8d="open8d"
                                    @edit="editNc"
                                />
                            </td>
                            <td>
                                {{ row.nc_causa }}
                                <div>{{ row.nc_origine }}</div>
                            </td>
                            <td>{{ row.problema || "Da compilare" }}</td>
                            <td>{{ row.correzione }}</td>
                            <td>{{ row.soluzione }}</td>
                            <td>
                                <files-n-c :numero="row.numero" :riga="row.riga" deferred />
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
        </v-data-iterator>
        </section>
        <nc-edit
            v-if="editingRow"
            :key="rowKey(editingRow)"
            :input="editingRow"
            :articolo="editingRow.articolo"
            :getdata="getData"
            open-on-mount
            @saved="onNcSaved"
            @dialog-change="onEditing"
        />
        <v-dialog v-model="confirmdialog" max-width="600" :persistent="bulkBusy">
            <v-card class="mc-root mc-dialog">
                <v-card-title>Conferma gestione materiale</v-card-title>
                <v-card-text>
                    Segnare il materiale come gestito per {{ selectedRows.length }} righe selezionate? La dichiarazione
                    e il rapporto 8D restano invariati.
                    <ul class="mt-3">
                        <li v-for="row in selectedRows" :key="rowKey(row)">
                            {{ row.numero }} / {{ row.riga }} · {{ row.articolo }}
                        </li>
                    </ul>
                </v-card-text>
                <v-card-actions
                    ><v-spacer /><v-btn text :disabled="bulkBusy" @click="confirmdialog = false">Annulla</v-btn>
                    <v-btn depressed color="primary" :loading="bulkBusy" @click="resolveSelected">Conferma</v-btn></v-card-actions
                >
            </v-card>
        </v-dialog>
      </div>
    </div>
</template>

<script>
import _ from "lodash";
import { teamLeaderMixin } from "../../mixins/teamleader";
import FilesNC from "../articoli/include/FilesNc.vue";
import BtArticolo from "../include/BtArticolo";
import NcListActions from "./include/NcListActions.vue";
import NcEdit from "./include/NcEdit.vue";
import Nc8dReprocess from "./include/Nc8dReprocess.vue";
import { ncRowKey, ncStage, markNcMaterialManaged, createNcListLoader } from "./include/ncList.mjs";
import autoRefreshMixin from "@/mixins/autoRefreshMixin";
import { bus } from "@/main";
import McPageHeader from "@/assets/mecom/vue/McPageHeader.vue";
import McStatusChip from "@/assets/mecom/vue/McStatusChip.vue";
import McStateMessage from "@/assets/mecom/vue/McStateMessage.vue";
import { date, number } from "@/assets/mecom/js/format.mjs";

export default {
    name: "RiepilogoNc",
    mixins: [teamLeaderMixin, autoRefreshMixin],
    components: { FilesNC, BtArticolo, NcListActions, NcEdit, Nc8dReprocess, McPageHeader, McStatusChip, McStateMessage },
    data: () => ({
        wantsTeamLeader: true,
        otherGroups: ["Amministrazione", "Qualità", "Milkrun", "Tecnici", "Magazzino", "Officina"],
        search: "",
        filtro8d: "all",
        opening8d: null,
        righe: [],
        total_items: 0,
        statusSummary: null,
        tableOptions: { page: 1, itemsPerPage: 50 },
        ready: false,
        loadSequence: 0,
        loading: true,
        loadError: "",
        bulkError: "",
        selected: [],
        confirmdialog: false,
        bulkBusy: false,
        editing: false,
        editingRow: null,
        filtro: { risolte: "", periodo: "tutti" },
        materialOptions: [
            { text: "Tutti", value: "" },
            { text: "Da gestire", value: "no" },
            { text: "Gestito", value: "si" },
        ],
        periodOptions: [
            { text: "Tutti", value: "tutti" },
            { text: "Ultimi 30 giorni", value: "ultimi_30_giorni" },
            { text: "Oltre 30 giorni", value: "oltre_30_giorni" },
        ],
    }),
    mounted() {
        document.title = "Work - Riepilogo NC";
        this.applyRoute();
        this.ready = true;
        this.setupAutoRefresh(300000);
        this.getData();
    },
    beforeDestroy() {
        this.loadSequence++;
        if (this.debouncedSearch) this.debouncedSearch.cancel();
    },
    created() {
        this.debouncedSearch = _.debounce(() => this.resetAndLoad(), 350);
    },
    watch: {
        socketMessage(value) {
            if (value && value.route === "nc") this.refreshData();
        },
        tableOptions: {
            deep: true,
            handler() {
                if (this.ready && !this.bulkBusy && !this.confirmdialog) this.getData();
            },
        },
        filtro8d() {
            if (this.ready) this.resetAndLoad();
        },
        search() {
            if (!this.ready) return;
            this.selected = [];
            this.loadSequence++;
            this.loading = true;
            this.statusSummary = null;
            this.debouncedSearch();
        },
        "$route.query"() {
            this.applyRoute();
            this.resetAndLoad();
        },
    },
    computed: {
        canManageNc() {
            const groups = this.$store.state.user.userdata.groups || [];
            return ["Amministrazione", "Qualità", "Milkrun", "Tecnici", "Magazzino"].some((group) => groups.includes(group));
        },
        socketMessage() {
            return this.$store.state.socketmessage;
        },
        selectedRows() {
            return this.righe.filter((row) => this.selected.includes(ncRowKey(row)) && row.risolta !== 2);
        },
        selectableRows() {
            return this.canManageNc ? this.righe.filter((row) => row.risolta !== 2) : [];
        },
        allSelected() {
            return this.selectableRows.length > 0 && this.selectedRows.length === this.selectableRows.length;
        },
    },
    methods: {
        formatDate: date,
        rowKey: ncRowKey,
        stage: ncStage,
        phaseLabel(row) {
            if (Number(row.numero_fase) === 999) return row.nc_origine || "Non produttiva";
            return row.numero_fase == null ? "—" : row.numero_fase;
        },
        count(key) {
            return this.statusSummary ? this.statusSummary[key] : "—";
        },
        formatCount(key) {
            return number(this.count(key), 0);
        },
        stageTone(row) {
            return row["8d_disponibile"] ? "good" : row.da_compilare ? "neutral" : "warn";
        },
        stageIcon(row) {
            return row["8d_disponibile"] ? "check" : row.da_compilare ? "minus" : "clock";
        },
        selectionDisabled(row) {
            return !this.canManageNc || row.risolta === 2 || this.loading || this.bulkBusy || this.confirmdialog;
        },
        selectPage(value) {
            this.selected = value ? this.selectableRows.map(ncRowKey) : [];
        },
        applyRoute() {
            const query = this.$route.query;
            this.filtro8d = ["unfilled", "incomplete", "pending"].includes(query.status_8d)
                ? "pending"
                : query.status_8d === "available" ? "available" : "all";
            this.filtro.risolte = ["si", "no"].includes(query.risolte) ? query.risolte : "";
            this.search = String(query.nc || query.search || "");
        },
        filtersChanged() {
            this.resetAndLoad();
        },
        refreshData() {
            if (!document.hidden && !this.selected.length && !this.confirmdialog && !this.bulkBusy) this.getData();
        },
        resetAndLoad() {
            this.selected = [];
            this.loadSequence++;
            this.loading = true;
            this.statusSummary = null;
            if (this.tableOptions.page !== 1) this.tableOptions.page = 1;
            else this.getData();
        },
        async getData() {
            if (this.bulkBusy || this.confirmdialog || this.editing) return;
            const sequence = ++this.loadSequence;
            this.loading = true;
            this.loadError = "";
            this.selected = [];
            try {
                if (!this.ncListLoader) this.ncListLoader = createNcListLoader(this.$work);
                const response = await this.ncListLoader(
                    {
                        scope: "all",
                        paginated: true,
                        page: this.tableOptions.page,
                        page_size: this.tableOptions.itemsPerPage,
                        search: String(this.search || "").trim(),
                        risolte: this.filtro.risolte,
                        periodo: this.filtro.periodo,
                        status_8d: this.filtro8d,
                    }
                );
                if (sequence !== this.loadSequence) return;
                const payload = response && response.data;
                if (
                    !payload ||
                    !Array.isArray(payload.results) ||
                    !payload.pagination ||
                    !payload.summary ||
                    !Number.isInteger(payload.summary.pending)
                )
                    throw new Error("Riepilogo completo non disponibile");
                this.righe = payload.results;
                this.total_items = payload.pagination.total;
                this.statusSummary = payload.summary;
                if (this.tableOptions.page !== payload.pagination.page)
                    this.tableOptions.page = payload.pagination.page;
            } catch (error) {
                if (sequence !== this.loadSequence) return;
                this.righe = [];
                this.total_items = 0;
                this.statusSummary = null;
                this.loadError =
                    error.response && error.response.status === 403
                        ? "Non hai i permessi per consultare le NC."
                        : "Impossibile caricare il riepilogo completo delle NC. Riprova ad aggiornare.";
            } finally {
                if (sequence === this.loadSequence) this.loading = false;
            }
        },
        onNcSaved() {
            this.getData();
        },
        editNc(row) {
            if (!this.canManageNc || this.loading || this.bulkBusy || this.confirmdialog) return;
            this.editing = true;
            this.loadSequence++;
            this.editingRow = row;
        },
        onEditing(value) {
            this.editing = value;
            if (value) this.loadSequence++;
            else {
                this.editingRow = null;
                this.getData();
            }
        },
        async resolveSelected() {
            if (!this.canManageNc || this.bulkBusy || this.loading || !this.selectedRows.length) return;
            this.bulkBusy = true;
            this.bulkError = "";
            try {
                const result = await markNcMaterialManaged(this.$work, [...this.selectedRows]);
                if (result.succeeded.length)
                    this.$toast.success(`Materiale gestito per ${result.succeeded.length} righe`, {
                        icon: "mdi-check-circle",
                        timeout: 4000,
                    });
                if (result.failed.length)
                    this.bulkError = `Esito non confermato per ${result.failed.join(
                        ", "
                    )}. Verifica lo stato aggiornato prima di riprovare.`;
            } finally {
                this.bulkBusy = false;
                this.confirmdialog = false;
                this.selected = [];
                await this.getData();
            }
        },
        async open8d(row) {
            if (this.opening8d) return;
            this.opening8d = ncRowKey(row);
            try {
                const response = await this.$work.get(`/arts/nc/${row.numero}/${row.riga}/8d/`, {}, true, null, {
                    responseType: "blob",
                    timeout: 15000,
                });
                const contentType = String((response.headers && response.headers["content-type"]) || "");
                const blob =
                    response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType });
                if (
                    !contentType.toLowerCase().includes("application/pdf") ||
                    !(await blob.slice(0, 5).text()).startsWith("%PDF")
                )
                    throw new Error("Risposta 8D non valida");
                bus.$emit("show-pdf", {
                    disegno: `Rapporto 8D ${row.numero} / riga ${row.riga}`,
                    minio: URL.createObjectURL(blob),
                    revokeOnClose: true,
                });
            } catch (error) {
                this.$toast.error("Impossibile aprire il rapporto 8D", { icon: "mdi-alert", timeout: 5000 });
            } finally {
                this.opening8d = null;
            }
        },
    },
};
</script>

<style scoped>
.nc-list {
    min-height: 100%;
}
.nc-filters {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-4);
}
.nc-filter-fields {
    margin: 0;
}
.nc-filter-fields > .col {
    padding: var(--space-1);
}
.nc-status-filters {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.nc-list .nc-status-filters > .v-btn.v-btn {
    height: auto !important;
    min-height: var(--touch-target);
    padding: var(--space-2) var(--space-3);
}
.nc-status-filters ::v-deep .v-btn__content {
    white-space: normal;
    line-height: 1.4;
}
.nc-selection {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--space-3);
    padding: var(--space-3) 0;
}
.nc-table {
    box-shadow: var(--shadow-card);
}
.nc-table ::v-deep td {
    min-width: calc(var(--space-8) * 2);
    max-width: calc(var(--space-8) * 4);
    overflow-wrap: anywhere;
    vertical-align: top;
    padding: var(--space-4) var(--space-3) !important;
    line-height: 1.5;
}
.nc-table ::v-deep th {
    padding: var(--space-3) !important;
}
.nc-table ::v-deep tbody tr {
    background: var(--surface);
}
.nc-table ::v-deep td:first-child {
    min-width: var(--space-8);
}
.nc-table ::v-deep .nc-identity {
    min-width: calc(var(--space-8) * 3);
}
.nc-table ::v-deep tr.status-8d-available > td:first-child {
    border-left: var(--space-1) solid var(--good);
}
.nc-table ::v-deep tr.status-8d-incomplete > td:first-child {
    border-left: var(--space-1) solid var(--warn);
}
.nc-mobile-list {
    display: grid;
    gap: var(--space-4);
    overflow-wrap: anywhere;
}
.nc-mobile-card ::v-deep .v-card__text {
    padding: 0;
    color: var(--ink);
    line-height: 1.5;
}
.nc-details {
    margin-top: var(--space-3);
    border-top: 1px solid var(--border);
}
.nc-details summary {
    cursor: pointer;
    min-height: var(--touch-target);
    padding: var(--space-3) 0;
    color: var(--brand-ink);
    font-weight: 500;
}
.nc-list ::v-deep .v-input--checkbox {
    color: var(--brand-ink);
}
.nc-list ::v-deep .v-btn.primary:not(.v-btn--outlined):not(.v-btn--text) {
    background-color: var(--brand) !important;
    border-color: var(--brand) !important;
    color: var(--on-brand) !important;
}
.nc-list ::v-deep .v-btn--text.primary--text {
    color: var(--brand-ink) !important;
}
.nc-list ::v-deep .v-data-footer {
    color: var(--ink-2);
    border-color: var(--border);
}
.nc-warning {
    display: flex;
    align-items: flex-start;
    gap: var(--space-3);
    padding: var(--space-4);
    border-radius: var(--radius-md);
    background: var(--warn-soft);
    color: var(--warn-ink);
}
.nc-warning .v-icon {
    color: inherit;
}
.nc-progress ::v-deep .v-progress-linear__indeterminate {
    background-color: var(--brand) !important;
}
@media (max-width: 600px) {
    .nc-status-filters {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .nc-status-filters > .v-btn:last-child { grid-column: 1 / -1; }
}
</style>
